import SearchIcon from '@heroicons/react/outline/SearchIcon'

import { useI18n } from '@tribeplatform/react-components/i18n'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { Input } from '@tribeplatform/react-ui-kit/Input'

export const FilterBar = ({ setFilters }) => {
  const intl = useI18n()
  return (
    <Card>
      <Card.Content>
        <Input
          leadingIcon={<SearchIcon />}
          onChange={e => setFilters({ query: e.target.value || undefined })}
          name="search"
          placeholder={intl.$t({
            defaultMessage: 'Search {SPACES}...',
            id: 'Search.Spaces.Placeholder',
          })}
        />
      </Card.Content>
    </Card>
  )
}
